import { lookAtBooks } from './places/books/books';

window.onload = () => {
  lookAtBooks();
}